(function () {
  if (window.__productCardSizesBound) return;
  window.__productCardSizesBound = true;

  const handle = (s) => (s || '').toString().trim().toLowerCase();
  const cssEscape = (s) => (window.CSS && CSS.escape ? CSS.escape(s) : s);

  function findRadioForValue(card, value) {
    const direct = card.querySelector(
      '.js-product-card-options input[type="radio"][value="' + cssEscape(value) + '"]'
    );
    if (direct) return direct;
    const target = handle(value);
    return Array.from(card.querySelectorAll('.js-product-card-options input[type="radio"]'))
      .find((r) => handle(r.value) === target) || null;
  }

  function optionKeyFor(fs, fallbackIdx) {
    const pos = parseInt(fs.dataset.optionPosition, 10);
    return 'option' + (Number.isFinite(pos) && pos > 0 ? pos : fallbackIdx + 1);
  }

  function getSelectedOptions(card) {
    const fieldsets = card.querySelectorAll('.js-product-card-options');
    const selected = {};
    fieldsets.forEach((fs, i) => {
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) selected[optionKeyFor(fs, i)] = checked.value;
    });
    return selected;
  }

  function updateFormIdForCurrentSelection(card) {
    if (!card || !card.variantsObj) return;
    const selected = getSelectedOptions(card);
    if (Object.keys(selected).length === 0) return;
    const variant = card.variantsObj.find((v) => {
      for (const key in selected) {
        if (v[key] !== selected[key]) return false;
      }
      return true;
    });
    if (variant) {
      const idInput = card.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;
    }
  }

  function syncProductCardAvailability(card) {
    if (!card || !card.variantsObj) return;
    const fieldsets = card.querySelectorAll('.js-product-card-options');
    if (!fieldsets.length) return;

    const selected = getSelectedOptions(card);

    fieldsets.forEach((fs, optIdx) => {
      const optionKey = optionKeyFor(fs, optIdx);
      const radios = fs.querySelectorAll('input[type="radio"]');
      radios.forEach((radio) => {
        const trial = Object.assign({}, selected);
        trial[optionKey] = radio.value;
        const ok = card.variantsObj.some((v) => {
          if (!v.available) return false;
          for (const key in trial) {
            if (trial[key] && v[key] !== trial[key]) return false;
          }
          return true;
        });
        const li = radio.closest('li');
        if (li) li.classList.toggle('disabled', !ok);
        radio.disabled = !ok;
      });
    });

    card.querySelectorAll('.product-card__size[data-size-value]').forEach((btn) => {
      const radio = findRadioForValue(card, btn.dataset.sizeValue);
      if (!radio) return;
      const isDisabled = !!radio.disabled;
      btn.classList.toggle('is-unavailable', isDisabled);
      btn.disabled = isDisabled;
      if (isDisabled) btn.classList.remove('is-active');
    });
  }

  function syncAllCards() {
    document.querySelectorAll('product-card').forEach(syncProductCardAvailability);
  }

  function init() {
    syncAllCards();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  // Re-sync when nodes are added (e.g., dynamically-loaded recommendations).
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((records) => {
      let shouldSync = false;
      for (const rec of records) {
        for (const node of rec.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('product-card')) { shouldSync = true; break; }
          if (node.querySelector && node.querySelector('product-card')) { shouldSync = true; break; }
        }
        if (shouldSync) break;
      }
      if (shouldSync) syncAllCards();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Capture-phase click handler — must run BEFORE the parent <a> default-navigates.
  document.addEventListener('click', function (e) {
    const sizeEl = e.target.closest('.product-card__size');
    if (!sizeEl) return;

    e.preventDefault();
    e.stopPropagation();

    if (!sizeEl.matches('[data-size-value]')) return;
    if (sizeEl.classList.contains('is-unavailable') || sizeEl.disabled) return;

    const card = sizeEl.closest('product-card');
    const wrap = sizeEl.closest('[data-product-card-sizes]');
    if (!card || !wrap) return;

    const radio = findRadioForValue(card, sizeEl.dataset.sizeValue);
    if (radio) radio.click();

    wrap.querySelectorAll('.product-card__size[data-size-value]').forEach((b) => {
      const isOn = b === sizeEl;
      b.classList.toggle('is-active', isOn);
      b.setAttribute('aria-pressed', isOn ? 'true' : 'false');
    });

    syncProductCardAvailability(card);
    updateFormIdForCurrentSelection(card);
  }, true);

  // Re-sync after any variant radio change.
  document.addEventListener('change', function (e) {
    const radio = e.target.closest('.js-product-card-options input[type="radio"]');
    if (!radio) return;
    const card = radio.closest('product-card');
    if (card) {
      syncProductCardAvailability(card);
      updateFormIdForCurrentSelection(card);
    }
  });
})();
